import React, { Component } from 'react';
import { request } from 'http';
import Q from './shared/Q'
import AmcAns from './shared/AmcAns'

export default class Head extends Component {
	state = {
		ans:-1
	}
	onAns(ans) {
		this.setState({ans})
	}
	Ans = {
		"< 6m" : "Less than 6 months",
		"1y" : "About a year",
		"2y" : "About 2 years",
		"3+" : "About 3 years or more",
	}
	render() {
		const {t,l} = this.props
		const {ans} = this.state
		return <Q q="How long ago did you buy your current Smartphone?" {...this.props}>
			{Object.keys(this.Ans).map((k,i) => <AmcAns on={ans === k} cb={_ => this.onAns(k)} ans={this.Ans[k]} 
			style={{
				position:"absolute",
				left: 20,
				top: 200 + 40 * i,
				width:360 - 48,
				height:30,
			}}/>)}
		</Q>	
	}
}



// WEBPACK FOOTER //
// ./src/dComp/HowLongAgoBuyCurrentSmartphone.js